import { createApp } from 'vue'
import { createPinia } from 'pinia'
import dayjs from 'dayjs';
import dayjsLocales from '../../services/dayjs-locales.service';
import localeData from 'dayjs/plugin/localeData';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isBetween from 'dayjs/plugin/isBetween';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import weekOfYear from 'dayjs/plugin/weekOfYear';
import Vue3TouchEvents, {
  type Vue3TouchEventsOptions,
} from "vue3-touch-events";

// Select the App you want to run on main, each individual are on /appName/App.vue
import App from './App.vue'

// import library styles
import '../../styles/tailwind.css'
import '@vueform/slider/themes/default.css'

// import custom styles
import './style.css'
import '../../styles/property_page.scss'

let locale = document.documentElement.lang;

async function loadLocale() {
  if (!dayjsLocales[locale]) {
    locale = 'default';
  }

  const localeData = await dayjsLocales[locale]().then(() => dayjs.locale(locale));
  dayjs.locale(localeData);
}

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);
const app = createApp(App);
app.use<Vue3TouchEventsOptions>(Vue3TouchEvents, {})

async function initApp() {
  await loadLocale();
  dayjs.extend(localeData);
  dayjs.extend(isoWeek);
  dayjs.extend(isSameOrBefore);
  dayjs.extend(customParseFormat);
  dayjs.extend(isBetween);
  dayjs.extend(weekOfYear);
  dayjs.localeData();

  app.config.globalProperties.$dayjs = dayjs;

  app.use(pinia)
  app.mount("#app")
}

initApp();
